import * as React from 'react'

export function DateCell({ row }) {
  const feedback = row.original

  const formattedDate = new Date(feedback.completed_at).toLocaleDateString(
    undefined,
    {
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
    },
  )

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        <div className="flex flex-col">{formattedDate}</div>
      </div>
    </div>
  )
}
